import type { AdminAiScanJsonDetailsProps } from "../../models/admin-ai-scans.models";
import { adminAiScansStyles } from "../../styles/admin-ai-scans.styles";
import { useState } from "react";

// Render every original key and array item as text, retaining nested evidence and notation.
// Mount nested entries only when opened and never execute report HTML or links.
const AdminAiScanJsonDetails = ({ value, label = "Report details" }: AdminAiScanJsonDetailsProps) => {
  const [expanded, setExpanded] = useState(false);

  if (value === null || typeof value !== "object") {
    return (
      <div className="min-w-0 py-1 text-sm leading-7">
        <p className="font-semibold">{label}</p>
        <p className="max-w-[90ch] whitespace-pre-wrap break-words text-gray-700 dark:text-gray-200">{String(value)}</p>
      </div>
    );
  }

  const entries = Array.isArray(value)
    ? value.map((item, index) => [String(index), item] as const)
    : Object.entries(value);

  return (
    <details className={adminAiScansStyles.details} onToggle={(event) => setExpanded(event.currentTarget.open)}>
      <summary className={adminAiScansStyles.summary}>
        {label} <span className="text-xs opacity-60">({entries.length})</span>
      </summary>
      {entries.length === 0 && <p className={adminAiScansStyles.muted}>{Array.isArray(value) ? "[]" : "{}"}</p>}
      {expanded && entries.map(([key, item]) => <AdminAiScanJsonDetails key={key} label={key} value={item} />)}
    </details>
  );
};

export default AdminAiScanJsonDetails;
